interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img 
            src="https://public.readdy.ai/ai/img_res/7a8be81f-3d83-4111-ae92-138c8d65622c.png" 
            alt="BRATELI DOO Logo" 
            className="h-10 w-10 object-contain"
          />
          <span className={`text-xl font-bold transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
            BRATELI DOO
          </span>
        </div>
        <div className="flex items-center gap-10">
          <button
            onClick={() => scrollToSection('about')}
            className={`text-sm font-light transition-colors hover:opacity-70 cursor-pointer ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            About
          </button>
          <button
            onClick={() => scrollToSection('products')}
            className={`text-sm font-light transition-colors hover:opacity-70 cursor-pointer ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            Products
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className={`text-sm font-light transition-colors hover:opacity-70 cursor-pointer ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            Contact
          </button>
        </div>
      </div>
    </nav>
  );
}